// @flow

import React, { type Node } from 'react';
import { TipsBox } from '../../../../../../commons/organisms';
import printIconSrc from './print-icon.svg';
import doNotPayIconSrc from './do-not-pay-icon.svg';
import smartphoneIconSrc from './smartphone-icon.svg';

export function EfectyTipsBox(): Node {
  return (
    <TipsBox title="Instrucciones de pago" tipsModel={[
      {
        imgSrc: printIconSrc,
        altText: 'payment method icon',
        tipText: 'Indica al cajero de tu punto efecty de preferencia el número de convenio y dicta el número de pago para que la operación se pueda hacer con éxito.',
      },
      {
        imgSrc: smartphoneIconSrc,
        altText: 'smartphone confirmation icon',
        tipText: 'La confirmación se realizará instantes después de completar el pago.',
      },
      {
        imgSrc: doNotPayIconSrc,
        altText: 'do not pay duplicate icon',
        tipText: 'Esta boleta es válida solamente para un código de pedido, no debe realizar un pago doble o uno de ellos será cancelado.',
      },
    ]}
    />
  );
}
